export const DEFAULT_API_PATH_DEV = 'https://4587459f-c043-48df-b7b9-a9605e0d47f4.mock.pstmn.io'
export const DEFAULT_API_PATH_PROD = '/api';
export const DEFAULT_API_PATH = '/api';
